import { Heading, Label, Paragraph } from '@/components/atoms/Typography'
import Icon, { IconName } from '@/components/atoms/Icon'
import GridColumn from '@/components/atoms/GridColumn'
import Grid from '@/components/atoms/Grid'
import Flex from '@/components/atoms/Flex'
import Areas from '@/components/atoms/Areas'

import { EntityItemProps } from './EntityItem.types'
import styles from './EntityItem.module.scss'

const EntityItem = ({ title, areas, infos, listNumber }: EntityItemProps) => {
  const formattedNumber = ('0' + (listNumber + 1)).slice(-2)

  return (
    <div className={styles.item}>
      <Grid noPadding>
        <GridColumn
          span={1}
          sm={12}
        >
          <Label
            size='md'
            weight='bold'
          >
            {formattedNumber}
          </Label>
        </GridColumn>
        <GridColumn
          span={4}
          sm={12}
        >
          <Heading
            size='md'
            weight='bold'
          >
            {title}
          </Heading>
        </GridColumn>
        <GridColumn
          span={3}
          sm={12}
        >
          <Areas items={areas} />
        </GridColumn>
        <GridColumn
          span={4}
          sm={12}
        >
          <Flex
            gap='24px'
            wrap
            className={styles.infos}
          >
            {infos.map((info) => (
              <Flex
                key={info.icon}
                alignItems='center'
                gap='8px'
              >
                <Icon
                  iconName={info.icon as IconName}
                  width={16}
                  height={16}
                  fill='white'
                />
                <Paragraph size='xs'>
                  {Array.isArray(info.value)
                    ? info.value.join(', ')
                    : info.value}
                </Paragraph>
              </Flex>
            ))}
          </Flex>
        </GridColumn>
      </Grid>
    </div>
  )
}

export default EntityItem
